import { type FC } from 'react';
import { BarHeader } from 'dibs-elements/exports/BarHeader.tsx';
import NoBarHeader from './NoBarHeader.tsx';
import OverlaySpinner from './OverlaySpinner.tsx';

import { loadingMessage } from './messages/sharedModalMessages.tsx';

import styles from './styles/LoadingModal.module.css';

const LoadingModal: FC<{ showSellerBranding?: boolean }> = ({ showSellerBranding }) => (
    <div className={styles.bodyMinHeight}>
        {showSellerBranding ? (
            <NoBarHeader title={loadingMessage} />
        ) : (
            <BarHeader title={loadingMessage} />
        )}
        <OverlaySpinner />
    </div>
);

export default LoadingModal;
